import React, { useState } from 'react';
import { FiPlus, FiSearch, FiFilter, FiMapPin, FiPhone, FiMail, FiUsers, FiChevronRight, FiX, 
         FiHash, FiCode, FiHome, FiMap, FiGlobe, FiToggleRight } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Hospital.css';
import Navbar from '../components/Navbar';
import { Link, useNavigate } from 'react-router-dom';

const hospitalsData = [
  {
    "id": "001",
    "code": "NBH001",
    "name": "North Hospital Branch",
    "email": "north@hospital.com",
    "phone": "+1 (555) 123-4567",
    "address": "123 Medical Ave",
    "city": "New York",
    "pinCode": "10001",
    "state": "NY",
    "country": "USA",
    "status": "active",
    "totalDoctors": 42,
    "totalPatients": 560,
    "rating": 4.8
  },
  {
    "id": "002",
    "code": "SMC002",
    "name": "South Medical Center",
    "email": "south@hospital.com",
    "phone": "+1 (555) 987-6543",
    "address": "456 Health Blvd",
    "city": "Los Angeles",
    "pinCode": "90001",
    "state": "CA",
    "country": "USA",
    "status": "active",
    "totalDoctors": 38,
    "totalPatients": 490,
    "rating": 4.6
  }
];

const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", 
  "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", 
  "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", 
  "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia",
  "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati",
  "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali",
  "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",
  "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
  "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay",
  "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
  "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa",
  "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
  "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",
  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

function Hospital() {
  const navigate = useNavigate();
  const [hospitals, setHospitals] = useState(hospitalsData);

  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingHospital, setEditingHospital] = useState(null);
  const [formData, setFormData] = useState({
    id: '',
    code: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    pinCode: '',
    state: '',
    country: '',
    status: 'active'
  });

  const toastConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      background: '#1f2937',
      color: '#fff',
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilterStatus(e.target.value);
  };

  const handleAddHospital = () => {
    setEditingHospital(null);
    setFormData({
      id: '',
      code: '',
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      pinCode: '',
      state: '',
      country: '',
      status: 'active'
    });
    setShowAddModal(true);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const hospitalData = {
      ...formData,
      totalDoctors: editingHospital ? editingHospital.totalDoctors : 0,
      totalPatients: editingHospital ? editingHospital.totalPatients : 0,
      rating: editingHospital ? editingHospital.rating : 0
    };

    if (editingHospital) {
      setHospitals(hospitals.map(hospital => 
        hospital.id === editingHospital.id ? { ...hospital, ...hospitalData } : hospital
      ));
      toast.success('Hospital updated successfully', toastConfig);
    } else {
      setHospitals([...hospitals, { ...hospitalData }]);
      hospitalsData.push({ ...hospitalData });
      toast.success('Hospital added successfully', toastConfig);
    }

    setShowAddModal(false);
  };

  const handleHospitalClick = (hospitalId) => {
    navigate(`/dashboard/hospital/${hospitalId}`);
  };

  const filteredHospitals = hospitals.filter(hospital => {
    const matchesSearch = hospital.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         hospital.location.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = filterStatus === 'all' || hospital.status === filterStatus;
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="hospital-page">
      <Navbar />
      <div className="hospital-container">
        <div className="hospital-header" style={{ animation: 'fadeIn 0.5s ease-out' }}>
          <div className="header-content">
            <div className="breadcrumb">
              <Link to="/dashboard">Dashboard</Link>
              <FiChevronRight className="breadcrumb-separator" />
              <span className="current">Hospitals</span>
            </div>
            <h1>Hospitals Management</h1>
            <p>Manage and monitor all hospital branches in one place</p>
          </div>
          <button className="add-hospital-btn" onClick={handleAddHospital}>
            <FiPlus size={20} /> Add New Hospital
          </button>
        </div>

        <div className="hospital-filters" style={{ animation: 'slideDown 0.5s ease-out' }}>
          <div className="search-box">
            <FiSearch className="search-icon" size={20} />
            <input
              type="text"
              placeholder="Search by hospital name or location..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="filter-box">
            <FiFilter className="filter-icon" size={20} />
            <select value={filterStatus} onChange={handleFilterChange}>
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="hospitals-grid" style={{ animation: 'fadeIn 0.7s ease-out' }}>
          {filteredHospitals.map((hospital, index) => (
            <div 
              key={hospital.id} 
              className="hospital-card"
              onClick={() => handleHospitalClick(hospital.id)}
              style={{ animation: `slideUp 0.5s ease-out ${index * 0.1}s` }}
            >
              <div className="hospital-card-header">
                <h3>{hospital.name}</h3>
                <div className="hospital-identifiers">
                  <span>ID: {hospital.id}</span>
                  <span>Code: {hospital.code}</span>
                  <span className={`status ${hospital.status}`}>
                    {hospital.status}
                  </span>
                </div>
              </div>
              
              <div className="hospital-info">
                <p>
                  <FiPhone size={16} />
                  <span>{hospital.phone}</span>
                </p>
                <p>
                  <FiMail size={16} />
                  <span>{hospital.email}</span>
                </p>
                <p>
                  <FiMapPin size={16} />
                  <span>{hospital.address}</span>
                </p>
                <div className="location-details">
                  <p>{hospital.city}, {hospital.state}</p>
                  <p>{hospital.pinCode}, {hospital.country}</p>
                </div>
              </div>

              <div className="hospital-stats">
                <div className="stat">
                  <FiUsers size={20} />
                  <div>
                    <h4>{hospital.totalDoctors}</h4>
                    <p>Doctors</p>
                  </div>
                </div>
                <div className="stat">
                  <FiUsers size={20} />
                  <div>
                    <h4>{hospital.totalPatients}</h4>
                    <p>Patients</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {showAddModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>
                <FiX size={24} />
              </button>
              <h2>{editingHospital ? 'Edit Hospital' : 'Add New Hospital'}</h2>
              <form onSubmit={handleFormSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Hospital ID</label>
                    <input
                      type="text"
                      value={formData.id}
                      onChange={(e) => setFormData({...formData, id: e.target.value})}
                      required
                      placeholder="Enter hospital ID"
                    />
                    <FiHash size={16} />
                  </div>
                  <div className="form-group">
                    <label>Hospital Code</label>
                    <input
                      type="text"
                      value={formData.code}
                      onChange={(e) => setFormData({...formData, code: e.target.value})}
                      required
                      placeholder="Enter hospital code"
                    />
                    <FiCode size={16} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Hospital Name</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    placeholder="Enter hospital name"
                  />
                  <FiHome size={16} />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      required
                      placeholder="Enter email address"
                    />
                    <FiMail size={16} />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      required
                      placeholder="Enter phone number"
                    />
                    <FiPhone size={16} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input
                    type="text"
                    value={formData.address}
                    onChange={(e) => setFormData({...formData, address: e.target.value})}
                    required
                    placeholder="Enter address"
                  />
                  <FiMap size={16} />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      value={formData.city}
                      onChange={(e) => setFormData({...formData, city: e.target.value})}
                      required
                      placeholder="Enter city"
                    />
                    <FiMap size={16} />
                  </div>
                  <div className="form-group">
                    <label>Pin Code</label>
                    <input
                      type="text"
                      value={formData.pinCode}
                      onChange={(e) => setFormData({...formData, pinCode: e.target.value})}
                      required
                      placeholder="Enter pin code"
                    />
                    <FiHash size={16} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>State</label>
                    <input
                      type="text"
                      value={formData.state}
                      onChange={(e) => setFormData({...formData, state: e.target.value})}
                      required
                      placeholder="Enter state"
                    />
                    <FiMap size={16} />
                  </div>
                  <div className="form-group">
                    <label>Country</label>
                    <select
                      value={formData.country}
                      onChange={(e) => setFormData({...formData, country: e.target.value})}
                      required
                      className="country-select"
                    >
                      <option value="">Select a country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                    <FiGlobe size={16} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={formData.status}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  <FiToggleRight size={16} />
                </div>
                <div className="form-actions">
                  <button type="submit" className="submit-btn">
                    <FiPlus size={20} />
                    {editingHospital ? 'Update Hospital' : 'Add Hospital'}
                  </button>
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => setShowAddModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}

export default Hospital;